// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from '../utils/axiosHandler';

const AuthContext = createContext(null);



export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
              
      // If user has a role stored, fetch role details
      if (parsedUser.role) {
        fetchUserRole(parsedUser.role, token);
      } else if (parsedUser.isAdmin) {
        // Handle legacy admin case - set default permissions
        setPermissions([
          'blog:manage', 'products:manage', 'categories:manage', 
          'templates:manage', 'orders:manage', 'clients:manage', 
          'marketing:manage', 'tickets:manage', 'pages:manage', 
          'menus:manage', 'notification:manage', 'system:manage'
        ]);
      }
    }
    setLoading(false);
  }, []);

  const fetchUserRole = async (roleId, token) => {
    try {
      const response = await axios.get(`/api/admin/roles/${roleId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const roleData = await response.data;
        setUserRole(roleData);
        
        // Extract permissions from role
        const perms = roleData.permissions.map(
          p => `${p.module}:${p.action}`
        );
        setPermissions(perms);
      }
    } catch (error) {
      console.error("Error fetching user role:", error);
    }
  };

  const hasPermission = (module, action) => {
    // Super admin check
    if (user?.isSuperAdmin) return true;
    
    // Legacy admin check
    if (user?.isAdmin && !userRole) return true;
    
    // 'manage' permission gives full access to a module
    return permissions.includes(`${module}:${action}`) || 
           permissions.includes(`${module}:manage`);
  };

  const login = (userData, token, noRedirect = false) => {
    setUser(userData);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));

      // Fetch role and permissions if user has a role
      if (userData.role) {
        fetchUserRole(userData.role, token);
      } else if (userData.isAdmin) {
        // Set default admin permissions
        setPermissions([
          'blog:manage', 'products:manage', 'categories:manage', 
          'templates:manage', 'orders:manage', 'clients:manage', 
          'marketing:manage', 'tickets:manage', 'pages:manage', 
          'menus:manage', 'system:manage'
        ]);
      }     

    // Redirect based on user role
    if (userData.isAdmin) {
      window.location.href = '/admin';
    } else if (!noRedirect){
      window.location.href = '/';
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';  // Redirect to home page
  };

  const refreshUser = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
  
      // Fetch updated user data from the server
      const response = await axios.get('/api/users/profile', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
  
      if (response.status === 200) {
        const userData = await response.data;
        // Update the user state with new data
        setUser(userData.user);
        // Update localStorage
        localStorage.setItem('user', JSON.stringify(userData.user));

        // Refresh role and permissions if user has a role
        if (userData.user.role) {
          await fetchUserRole(userData.user.role, token);
        }

      } else {
        console.error('Failed to refresh user data');
      }
    } catch (error) {
      console.error('Error refreshing user data:', error);
    }
  };

  return (
    <AuthContext.Provider value={{
       user,
        login,
        logout,
        loading,
        refreshUser,
        userRole,
        permissions,
        hasPermission,
        isAuthenticated: !!user,
        isAdmin: user?.isAdmin || false
        }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);











// // wrpke well before role based admins
// // src/context/AuthContext.js
// import React, { createContext, useState, useContext, useEffect } from 'react';

// const AuthContext = createContext(null);



// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     const userData = localStorage.getItem('user');
//     if (token && userData) {
//       setUser(JSON.parse(userData));
//     }
//     setLoading(false);
//   }, []);

//   const login = (userData, token, noRedirect = false) => {
//     setUser(userData);
//     localStorage.setItem('token', token);
//     localStorage.setItem('user', JSON.stringify(userData));

     

//     // Redirect based on user role
//     if (userData.isAdmin) {
//       window.location.href = '/admin';
//     } else if (!noRedirect){
//       window.location.href = '/';
//     }
//   };

//   const logout = () => {
//     setUser(null);
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
//     window.location.href = '/';  // Redirect to home page
//   };

//   const refreshUser = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       if (!token) return;
  
//       // Fetch updated user data from the server
//       const response = await fetch('/api/users/profile', {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       });
  
//       if (response.ok) {
//         const userData = await response.json();
//         // Update the user state with new data
//         setUser(userData.user);
//         // Update localStorage
//         localStorage.setItem('user', JSON.stringify(userData.user));
//       } else {
//         console.error('Failed to refresh user data');
//       }
//     } catch (error) {
//       console.error('Error refreshing user data:', error);
//     }
//   };

//   return (
//     <AuthContext.Provider value={{ user, login, logout, loading, refreshUser  }}>
//       {!loading && children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);






